import * as React from 'react';

import PropTypes from 'prop-types';

export class DateStat extends React.Component {
    static propTypes = {
        value: PropTypes.shape({
            formatted: PropTypes.string.isRequired,
            units: PropTypes.string,
        }).isRequired,
    };

    render() {
        const numDays = this.props.value.formatted;
        const units = this.props.value.units ? this.props.value.units : 'days';

        return <div>{`${numDays} ${units}`}</div>;
    }
}
